<template>
    <div>
        <div class="controls">
            <v-btn small dense color="primary" class="mr-1" @click="moveIndex('up')">
                <i class="bx bx-chevrons-up bx-sm"></i>
            </v-btn>
            <v-btn small dense color="primary" class="mr-1" @click="moveIndex('down')">
                <i class="bx bx-chevrons-down bx-sm"></i>
            </v-btn>
            <v-btn class="row-remover" @click="openDeleteConfirmation" small dense color="error">
                <i class="bx bxs-trash bx-xs"></i>
            </v-btn>
        </div>

        <v-dialog v-model="confirmations.delete" width="400">
			<v-card class="pa-5 text-center">
				<h4 class="red--text">Deletion Warning!</h4>
				<div class="font-italic">Are you sure that you want to remove this row?</div>
                <div class="mt-5">
                    <v-btn dense color="primary" class="mr-1" small @click="confirmations.delete = false">Cancel</v-btn>
                    <v-btn dense color="error" small @click="deletionConfirmed">Remove Row</v-btn>
                </div>
			</v-card>
		</v-dialog>
    </div>
</template>

<script>

export default {
    props: ["rowIndex"],
    data () {
        return {
            modals: {
                show: false,
                success: null,
                message: null
            },
            confirmations: {
                delete: false
            }
        }
    },
    methods: {
        openDeleteConfirmation () {
            this.confirmations.delete = true
        },
        deletionConfirmed () {
            this.removeRow(this.rowIndex)
            this.confirmations.delete = false
        },

        moveIndex (moveTo) {
            const index = this.rowIndex
            const temp = this.elements[index]
            const firstItem = this.elements[0]
            if (moveTo == "down" && index != 0) {
                this.elements[index] = this.elements[index + 1]
                this.elements[index + 1] = temp
            }
            else if (moveTo == "up" && index != 1) {
                this.elements[index] = this.elements[index - 1]
                this.elements[index - 1] = temp
            }
            // this is so the DOM updates when array changes
            this.elements.shift()
            this.elements.unshift(firstItem)
        }
    }
}
</script>
